import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isEmpty, size } from 'lodash';
import RegisterProspectFormList from './registerProspectList.jsx';
import PlanInstallationJsonForm from './planInstallation.jsx';
import RegisterInstallationJsonForm from './registerInstallation.jsx';

import ClientTab from './ClientTab.jsx';
import Dialog from '../../../commonModules/interface/Dialog.jsx';
import Notif from '../../../commonModules/interface/Notif.jsx';
import PaygPopupInfo from '../paygPopupInfo.jsx';
import { askDevis } from '../../../../../../jsx/actions/devisAction'
import { fetchProspectsType } from '../../../../../../jsx/actions/prospectAction';
import { fetchAgents, fetchInstallers } from '../../../../../../jsx/actions/paygAction';
import { fetchSubscriptions } from '../../../../../../jsx/actions/subscriptionAction';

import InputText, { TextArea ,InputSelect} from '../../../commonModules/interface/form-input-inline.jsx';
import Currency from '../../../commonModules/Currency.jsx';
import { Link, TableContainer, Table,Button, Grid, TableHead, TableBody, TableRow, TableCell, IconButton, Box, CircularProgress, Typography } from '@material-ui/core';
import PopUp from '../../../commonModules/interface/PopUp.jsx';
import { TableLayout } from '../Stock/containers/Layout.jsx';
import { AddCircleRounded,CheckBoxRounded, AssignmentOutlined, DeleteOutlineRounded, MoreVertRounded, CloseRounded, SyncRounded, MenuRounded } from '@material-ui/icons';
import FormLayout from '../Stock/containers/FormLayout.jsx';
import Spin from '../../../commonModules/interface/Spin.jsx';
import TableFooterPagination from '../../../commonModules/interface/TableFooterPagination.jsx';
import { Alert, AlertTitle } from '@material-ui/lab';
import CardButton from '../../../commonModules/interface/CardButton.jsx';
import { blue } from '@material-ui/core/colors';
import ProductLineCell from '../Stock/containers/ProductLineCell';

const initErrors = {
    shop: "",
    shop_dest: "",
    cli_type: "",
    quantity: "",
    nature:"",
    transport:"",
    discount:"",
    taxes:"",
    products:[
        {
            product_id:"",
            quantity:"",
        }
    ],
}

const initSale = {
    shop: "",
    client_ref: "",
    sale_paygo_id: "",
    cli_type: "",
    nature:"",
    transport:0,
    taxes:0,            
    comments:"",
    discount:0,
    total:0,
    products:[
        {
            display:{value:"", label:""},
            product_id:"",
            quantity:"",
            max:"",
        }
    ],
}

const NAMES = {
    "Prospect": "Prospect", 
    "WaitForValidation": "Client",
    "WaitForPayment": "Client",
    "HasPayed": "Client",
    "WaitForInstallation": "Client",
}
class ClientList extends Component {
    state = {
        MAX_LENGTH: 10, // Define the max number of element
        headerMenu: "Prospect",
        popupState: false,
        recapChange: "",
        popupChangeTech: "",
        popupStateValidationContrat: false,
        subscriptionlist: [{id: "", idobj: "none", needProductID: "",status:"",stocklink:""}],
        contratValue: "",
        contratLabel: "",
        sellerAgent: "",
        contratName: "",
        commission: 0.0,
        subscriptionlistValue: "",
        popupStateValidationProspect: false,
        jsonSchemaProspect: {},
        uiSchemaProspect: {},
        popupStateValidationPayment: false,
        popupStateHasPayed: false,
        installatorlist:  [],
        popupStateInstallation: false,
        userID: "",
        popupUserInfo: false,
        clientInfo: {},
        productID: "",
        error: "",
        contratNeedStockManagement: false,
        prospectOptions : false,
        prospectOptionsInfos : "",
        notif:{
            title:"", 
            type: "", 
            message:"",
            show:false
        },
        disabledValidationButton: false,
        mdpAdmin:"",
        currentPage: 0,
        rowsPerPage: 20,

        filteredList:[],
        currentList: [],
        search: "",
        comment:"",

        // To manage product sales output
        numberProd: 1,
        form:[],
        stocks:[],
        sale: Object.assign({}, initSale),
        errors: Object.assign({}, initErrors),
        contratValueNeedProductID : false, 
        contratNeedStockManagement: false,
        fetchingStocks: false,
        updateDisplay: true,
    };

    componentDidMount = async () => {
        console.log('[INFO], componentDidMount, ', this.props.commercialList )
        let req = [this.fetchLists(true)]
        if(isEmpty(this.props.SUBSCRIPTIONS)){
            req.push(this.props.fetchSubscriptions())
        }
        if(isEmpty(this.props.INSTALLERS)){
            req.push(this.props.fetchInstallers())
        }
        await Promise.all(req)
        
        if (this.props.commercialList == null){
            console.log("GET Commercial List");
            this.props.fetchAgents()
        }
        this.fetchSubscriptions()
        this.fetchInstallers()
        
                
    }
    // FETCH REQUESTS
        fetchLists = (firstCall = false) => {
            const { PROSPECTS } = this.props;
            let headerMenu = [
                "Prospect", 
                "WaitForValidation",
                "WaitForPayment",
                "HasPayed",
                "WaitForInstallation",
                // "Refused"
            ]
            headerMenu.forEach(async menu => {
                console.log('====================================');
                console.log("in async", menu);
                console.log('====================================');
                if(firstCall) {
                    if(isEmpty(PROSPECTS[menu]) ) {
                        await this.props.fetchProspectsType(menu)    
                    }
                } else {
                    await this.props.fetchProspectsType(menu)    
                }
            })
        }
        fetchListsPayment = () => {
            let headerMenu = [
                "WaitForValidation",
                "WaitForPayment",
            ]
            headerMenu.forEach(async menu => {
                await this.props.fetchProspectsType(menu)    
            })
            this.setState({updateDisplay: !this.state.updateDisplay})
            // Promise.all([
            //     this.fetchWaitingValidation(),
            //     this.fetchWaitingPayment(),
            // ]) // resolve all requests at the same time
        }
        
        fetchSubscriptions = () => {
            let methodName = "clientList fetchSubscriptions ";
            const { SUBSCRIPTIONS } = this.props;

            var optionTmp = [];
            optionTmp.push({id: "", idobj: "none"})
            try {
                Object.values(SUBSCRIPTIONS).forEach(sub => {
                    optionTmp.push({
                        id: sub.name, 
                        idobj: sub.id,
                        needProductID: sub.needProductID, 
                        status:sub.status,
                        stocklink: sub.stocklink
                    })
                })
            } catch (e) {
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e);
                return;
            }
            // console.log("[SUCCESS], received subscription list sucessfully",optionTmp);
            this.setState({subscriptionlist: optionTmp, subscriptionlistValue: ""});
        }
        fetchInstallers = () => {
            let methodName = "clientList fetchInstallers ";
            const { INSTALLERS } = this.props;

            var optionTmp = [];
            optionTmp.push({id: "", idobj: "none"})
            try {
                Object.values(INSTALLERS).forEach( tech => {
                    optionTmp.push({id: tech.name, idobj: tech.id})
                })
            } catch (e) {
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); 
                return;
            }
            // console.log("[SUCCESS], received installater list sucessfully");
            this.setState({ installatorlist: optionTmp });
            
        }

    createClientList = () => {
        console.log('===============createClientList=====================');
        console.log('==================START==================');

        const { headerMenu, rowsPerPage, currentPage, MAX_LENGTH  } = this.state;
        const { PROSPECTS } = this.props;
        if (isEmpty(PROSPECTS[headerMenu])){
            return []
        }
        let contentHeaderTmp = PROSPECTS[headerMenu].headers
        let contentArrayTmp = this.filterList()

        let contentArray = [];

        console.log('====================================');
        console.log({contentHeaderTmp, contentArrayTmp});
        console.log('====================================');

        contentArrayTmp.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map( userInfo => {
            let arrayInfo = [];
            let max = size(contentHeaderTmp) > MAX_LENGTH ? MAX_LENGTH : size(contentHeaderTmp);

            for ( let i = 0; i < max; i++ ){
                arrayInfo.push(
                    <TableCell onClick={() => this.userDescriptionHandler(userInfo.ID, userInfo)}>
                        {this.checkItemIfImg(userInfo[contentHeaderTmp[i]])}
                    </TableCell>
                );
            }

            
            ( headerMenu !== "WaitForPayment" ) ? (
                arrayInfo.push( 
                    <TableCell> 
                        <IconButton 
                            color="secondary"
                            // className="btn btn-warning btn-icon-text" 
                            onClick={() => this.setState({
                                prospectOptions: true, 
                                prospectOptionsInfos: userInfo
                            }) } 
                            title="Voir les options"
                        >
                            <MenuRounded />
                        </IconButton> 
                    </TableCell>
                )
            ) : (
                arrayInfo.push( 
                    <TableCell> 
                        <Button 
                            // className="btn btn-success btn-icon-text" 
                            color="primary"
                            variant="contained"
                            onClick={() => this.ClickForValidation(userInfo.ID)} 
                            title="Valider cette étape"
                        >
                            Validation
                        </Button> 
                    </TableCell>
                )
            )
            // if (headerMenu === "WaitForInstallation"){
            //     arrayInfo.push( 
            //         <TableCell> 
            //             <IconButton 
            //                 onClick={() => this.changeInstallateur(userInfo.ID)} 
            //                 title="Changer Installateur"
            //                 color="secondary"
            //             >
            //                 <SyncRounded />
            //             </IconButton> 
            //         </TableCell>
            //     )
            // }
           
            contentArray.push( 
                <TableRow key={userInfo.ID} id={userInfo.ID} hover>
                    {arrayInfo}
                </TableRow>
            )
        })
        return {list: contentArray, all: contentArrayTmp}
    }
        
    getName = (idUser) => {
        const { PROSPECTS } = this.props;
        const { headerMenu } = this.state;
        let translate = {
            "Homme": "M.",
            "Femme": "Mme."
        }
        
        // Check if the list and user exist before accessing properties
        const userInfo = PROSPECTS[headerMenu]?.list?.[idUser];
        if (!userInfo) {
            console.log('[WARN] ClientList, getName, User not found for idUser:', idUser);
            return "";
        }
        
        let name = userInfo.Nom || "";
        let gender = translate[userInfo.Type] || "";
        let surname = userInfo.Prénom || "";
        console.log('[INFO] ClientList, getName, Iduser,',idUser);
        
        return gender + " "+name+ " "+surname;
    }
    changeInstallateur = (item) => {
        console.log("[INFO], Commercial, changeInstallateur,", item);
        
        this.setState({
            popupChangeTech: true,
            userToChange: item
       });
    }
    ClickForValidation = (item) => {
        console.log("[INFO], Commercial, ClickForValidation,", item);
        //Must then Create a Dialog Box for Validation
        switch (this.state.headerMenu) {
            case "Prospect":
                // prospect list open pop up to choose an action : VALIDATION, ASK DEVIS, DELETE
                this.setState({
                    popupStateValidationProspect: true,
                    userToChange: item
                });
                break;
            case "WaitForValidation":
                this.setState({
                    popupStateValidationContrat: true,
                    userToChange: item
                });
                break;
            case "WaitForPayment": 
                //Step For Payment Validation
                this.setState({
                    popupStateValidationPayment: true,
                    userToChange: item
                });
                break;
            case "HasPayed": 
                 // Step For Preparing installation
                 this.setState({
                    popupStateHasPayed: true,
                    userToChange: item
                });
                break;
            case "WaitForInstallation":
                //Step For Preparing installation
                this.setState({
                    popupStateInstallation: true,
                    userToChange: item
               });
                break;
        }
    }
    askDevis = async (prospectOptionsInfos) => {
        // const { prospectOptionsInfos } = this.state;
        console.log("Ask Devis for ", prospectOptionsInfos);
        try {
            await this.props.askDevis(prospectOptionsInfos)
             
            if (this.props.STATE.devis.error ){
                console.log("[ERROR], ask for devis response ",this.props.STATE.devis.error)                   
                this.notif("danger", this.props.STATE.devis.error)
                return;
            }
            
            this.notif("info", "La demande a été transférée")
            
        } catch (err) {
            console.log("[ERROR], ask for devis data",err)
            this.notif("danger", "Un problème est survenu")
        }

        this.handleClose()
    }
    cancelChange = (e) => {
        e.preventDefault();
        this.setState({
            recapChange: "",
            popupState: false,
            userToChange: "",
            error: "",
            disabledValidationButton: false,
        });
    }
    validChange = (e) => {
        this.setState({
            disabledValidationButton: true,
        })
        e.preventDefault();
        console.log("[INFO], Valid Change for user, ", this.state.userToChange, " from ", this.state.headerMenu)

        //Send to back for change
        switch (this.state.headerMenu){
            case "WaitForValidation":
                let result = this.updateStatusUser(this.state.userToChange, 1); // important 1 = "WaitForValidation", 2 = "WaitForPayment" ..
                //must suppres value from the list
                console.log('[INFO], Result for valid Change, ',result);    
                break;
            case "WaitForPayment":
                result = this.recordPayment(this.state.userToChange);
                console.log('[INFO], Result for valid payment,',result);
                break;
        }
    }
    
    recordPayment = async (userId) => {
        console.log("[INFO], request for Update Payment of user : ",userId);
        //Send HTTP Request 
        try {
            const response = await fetch('/user/prospect/update/payment', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body: JSON.stringify({
                    boxAssoId: userId,
                }),
                credentials: 'same-origin',                    
            });            
            const resp = await response.json();
            console.log(resp);
            if (resp.msg != "OK" ){
                console.log("[ERROR], getting prospect response ",resp);  
                return "Reponse not OK";
            }
            this.setState({
                recapChange: "",
                popupState: false,
                userToChange: ""
            });
            this.fetchLists();
            return "OK";
        } catch (err) {
            console.log("[ERROR], getting prospect data",err);
            return err;            
        }
    }
    updateStatusUser = async (userId, step) => {
        console.log("[INFO], request for Update status of user : ",userId, " to step ",step);
        // Send HTTP Request 
        console.log("[INFO], request info : ",this.state.comment, " >> ",this.state.commission);
        // Check stock
        const { SUBSCRIPTIONS, commercialList } = this.props;
        var stockMandatory = false
        if (SUBSCRIPTIONS[this.state.contratValue].stocklink === "mandatory" ||
        SUBSCRIPTIONS[this.state.contratValue].stocklink==="optional" ){
            let productLenght = 0 
            stockMandatory = true
            this.state.sale.products.map( (item)=>
                {
                    if (item.quantity > 0 && item.display.value !== ""){
                        console.log("[DEBUG], Product >>> ",item," - " ,item.quantity )
                        productLenght++
                    }
                }
            )
            console.log("[INFO], Product Size",productLenght )
            if (productLenght <= 0){
                this.setState({error: "Product could not be sold without stocks"});                 
                return
            }
        }

        try {
            var stockManagementInfo = null
            if (stockMandatory){
                stockManagementInfo = this.state.sale.products
            }
            const response = await fetch('/user/prospect/update', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    // 'X-Requested-With': 'XMLHttpRequest',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body: JSON.stringify({
                    step: step,
                    boxAssoId: userId,
                    schemaID : "",
                    info: {
                        subscriptionID: this.state.contratValue, 
                        productID: this.state.productID,
                        commission: parseFloat(this.state.commission),
                        comment: this.state.comment,
                        sellerAgent: this.state.sellerAgent,
                    },
                    stockManagement: stockManagementInfo,
                    stockManagementAccount: this.state.stocks.account_id
                }),
                credentials: 'same-origin',                    
            });            
            const resp = await response.json();
            console.log(resp);
            if (resp.msg != "OK" ){
                console.log("[ERROR], getting prospect response ",resp);  
                console.log("[ERROR], getting prospect response ",resp.error);  
                console.log("[ERROR], getting prospect response ",resp.error.error);  
                this.setState({error: resp.error.error.content});                 
                return "Reponse not OK";
            }
            this.setState({
                recapChange: "",
                popupState: false,
                userToChange: "",
                error: "",
                disabledValidationButton: false,
                contratValue: "", 
                contratLabel: "", 
                stocks:[],
                numberProd: 1,
                sale: Object.assign({}, initSale),
                errors: Object.assign({},initErrors),
                contratValueNeedProductID : false, 
                contratNeedStockManagement : false,
            });
                 
            this.cancelInput()
            this.fetchLists();
            return "OK";

        } catch (err) {

            console.log("[ERROR], getting prospect data",err);
            this.setState({error: "Error connexion"});                 
            return err;            
        }

    }
    cancelInput = (e) => {
        initSale.products = [
            {
                display:{value:"", label:""},
                product_id:"",
                quantity:"",
                max:"",
            }
        ]
        this.setState({
            popupStateValidationContrat: false,
            popupStateValidationProspect: false,
            popupStateValidationPayment: false,
            popupStateInstallation: false,
            popupStateHasPayed: false,
            popupChangeTech:  false,
            popupUserInfo: false,
            numberProd: 1,
            stocks:[],
            sale: Object.assign({}, initSale),
            errors: Object.assign({}, initErrors),
            contratValueNeedProductID : false, 
            contratNeedStockManagement: false,
            fetchingStocks: false
    
        });
    }
    validContrat = (e) => {
        let recapChange = "";
        let produit = "";
        // Check if product is needed
        if (this.state.contratNeedStockManagement){
            console.log("NEED Stock");
            if (isEmpty(this.state.sale.products)){
                return ;
            }
            // Check quantity is not null
            this.state.sale.products.map(
                (item)=> {
                    if (item.quantity <= 0){
                        console.log("[ERROR], Stock is empty ",item)
                        return
                    }
                }
            )
        }
        if (this.state.productID != ''){
            produit = 'avec le numéro produit '+ this.state.productID
        }
        if (this.state.popupStateValidationContrat) {
            recapChange = "Etes-vous sur de vouloir valider "+ this.getName(this.state.userToChange) +" pour un contrat " + this.state.contratLabel +" "+ produit + " ? ";
            this.setState({
                // popupStateValidationProspect: false,
                // popupStateValidationContrat: false,
                // popupStateHasPayed: false,
                // popupStateInstallation: false,
                popupState: true,
                headerNamePopupName: "Validation Attribution Contrat",
                recapChange: recapChange,
            })
        } else {
            this.setState({
                popupStateValidationProspect: false,
                popupStateValidationContrat: false,
                popupStateHasPayed: false,
                popupStateInstallation: false,
                popupState: false,
                popupChangeTech: false,
                recapChange: recapChange
            });
        }
        this.handleClose();
        this.fetchLists();
    }
    validPayment = (e) => {
        e.preventDefault();
        console.log('[INFO], Validation payment pour : ', this.getName(this.state.userToChange) );

        let recapChange = "Etes-vous sur de vouloir valider le paiement pour "+ this.getName(this.state.userToChange) +" ? ";
        this.setState({
            popupStateValidationPayment: false,
            popupState: true,
            recapChange: recapChange,
            headerNamePopupName: "Valider Paiement" 
        });
        this.fetchListsPayment();
    }
    onChangeProductID = (e) => {
        e.preventDefault();
        var productID = e.target.value;
        this.setState({productID: productID});
    }
    checkItemIfImg = (val) => {
        
        var re = new RegExp("data:image*");
        if (re.test(val)){
            return <img src={val} width="200" height="200"/>;
        } else {
            return val;
        }
    }
    userDescriptionHandler = (ID, clientInfo) => {
        console.log("[DEBUG], Get Info for : ",ID);
        // Open a new frame And
        this.setState({popupUserInfo: true, userID: ID, clientInfo})
    }
   
    handleChange = (e) => {
        const field = e.target.name
        const value = e.target.value
        this.setState({
            [field]: value
        })
    }
    
    handleClose = () => {
        this.setState({
            prospectOptions : false,
            prospectOptionsInfos: "",
            mdpAdmin: "",
            confirmDelete:false
        })
    }

    filterList = (header = this.state.headerMenu, search = this.state.search) => {
        const { PROSPECTS } = this.props;        
        let list = Object.values(PROSPECTS[header].list)
        let filteredValues = []
        let valueList = Object.values(list)
        
        if(!search || isEmpty(valueList)) {
            return valueList
        }

        let fields = Object.keys(valueList[0]);
        valueList.filter(client => {
            let match = fields.filter(field => ( 
                typeof client[field] === "string" 
                && client[field].toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) > -1  
            ))    
            if (match.length > 0) {
                filteredValues.push(client)
            }
        })
        return filteredValues
    }
    fetchCommercialStocks = async (commercialID) => { // move to redux
        let stocks = []
        this.setState({ fetchingStocks: true, sellerAgent: commercialID })
        try {
            const response = await fetch('/stocks/commercial/agent/stockList/old',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body: JSON.stringify({commercialID}),
                credentials: 'same-origin',
            }); 
            
            const list = await response.json()
            console.log("fetchCommercialStocks",list)// list returns new object created
            if(list.error){ // no errors, return new Object
                console.log("error list fetched", list.error)
            } else {
                stocks = list
            }
            
        } catch (err) {
            console.log("catch error", err)
        }

        this.setState({ 
            // sellerAgent: commercialID,
            numberProd: 1,
            stocks:stocks,
            sale: Object.assign({}, initSale),
            errors: Object.assign({},initErrors), 
            fetchingStocks: false
        }) 
    }
    deleteClient = async () => {
        const { prospectOptionsInfos, mdpAdmin } = this.state;
        if (mdpAdmin !== ""){

            try {
                const response = await fetch('/user/prospect/delete', {
                    method: 'POST',
                    body: JSON.stringify({
                        boxassoid: prospectOptionsInfos.ID,
                        mdpAdmin: mdpAdmin
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                        //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                    },
                    credentials: 'same-origin',                    
                });            
                const resp = await response.json();
                console.log(resp);
                if (resp.msg != "OK" ){
                    console.log("[ERROR], delete client response ",resp)   
                    this.notif("danger", resp.error)                
                    return;
                }
                
                this.notif("info", "Le client a été supprimé")
                this.handleClose()

            } catch (err) {
                console.log("[ERROR], delete client",err)
            }
        } else {
            this.notif("danger", "Mot de passe incorrect")
        }
    }
    createAddFormOLD = () => {
        const tab = []
        console.log("createAddForm >> ", this.state.sale.products)
        let products = [{value:"", label:"Chosissez un Produit"}]
        this.state.stocks.forEach( item => {
            //console.log(item);
            let selected = false
            this.state.sale.products.forEach( prod => {   
                if( prod.product_id  === item.product.id)   {  // already selected   
                    selected = true 
                } 
            })
            if (item.quantity !== 0 ){
                products.push (       
                    { 
                        value: item.product.id, 
                        label: `${item.product.marque} - ${item.product.name} `, 
                        disabled: selected,
                        max: item.quantity,
                        stock_id: item.id
                    } 
                )
            }
        })
        // console.log("createAddForm >> ", this.state.stocks,"  -  ",this.state.numberProd )
        // console.log("createAddForm >> ", products )
        // console.log("createAddForm >> ", this.state.sale )
        for (let i = 0; i < this.state.numberProd;i++) {
            tab.push( 
            <TableRow key={i}>             
                <TableCell style={{ minWidth: "450px"}}>
                    {i !== 0 &&
                    <IconButton
                        type="button" 
                        color="secondary"
                        onClick={() => this.handleDeleteProd(i)}
                    >
                        <CloseRounded color="error" />
                    </IconButton>
                    }
                    <InputSelect
                        label={`Produit ${i+1}`}
                        options={products}
                        value={this.state.sale.products[i].product_id}
                        placeholder="Selectionner un Produit"
                        onChange={ option => this.handleSelectProducts(option, i ) }
                        // isOptionDisabled={ option => option.disabled === true}
                        error={this.state.errors.products[i].product_id}
                    />    
                </TableCell>

                <TableCell className="text-center" style={{ width: "150px" }}>
                    <InputText 
                        type="number" 
                        min={1} 
                        max={this.state.sale.products[i].max} 
                        className="form-control input-sm" 
                        onChange={this.handleChangeStock} 
                        value={this.state.sale.products[i].quantity } 
                        name={"prod_-quantity-" + i} 
                        title="Quantité"
                        error={this.state.errors.products[i].quantity}
                        helperText={this.state.sale.products[i].max ? "Disponible : "+ this.state.sale.products[i].max : "" }
                    />
                </TableCell>
            </TableRow>  
            )
        }
        return tab
    }

    handleSelectProducts = (option, index) => {
        console.log("SELECT HANDLE",{option, index});

        let value = option.value
        // const max = this.findMax(value)    
        let cpSale = Object.assign({}, this.state.sale)
        let cpProducts = cpSale.products

        cpProducts[index].product_id = value
        // cpProducts[index].max = max[0]
        // cpProducts[index].stock_id = max[1]
        cpProducts[index].max = option.max
        cpProducts[index].stock_id = option.stock_id
        cpProducts[index].display = option
        
        this.setState({
            ...this.state,
            sale: cpSale
        })        
    }

    handleDeleteProd = (index) => {
        this.setState({
            ...this.state,
            sale:{
                ...this.state.sale,
                products:[
                    ...this.state.sale.products.slice(0,index),
                    ...this.state.sale.products.slice(index +1),
                ]
            },
            errors:{
                ...this.state.errors,
                products:[
                    ...this.state.errors.products.slice(0,index),
                    ...this.state.errors.products.slice(index +1),   
                ]
            },
            numberProd:this.state.numberProd - 1,
        })   
    }
    handleChangeStock = (e) => {  
        console.log("[INFO], handleChangeStock, ",e.target.name, " >> ", e.target.value)
        const field = e.target.name
        const value = e.target.value
        const regex = /^[0-9\b]+$/ // int only
        
        if(field.startsWith("prod_")){
            // field = "prod_-quantity-4" ...

            let splitTab = field.split("-")
            let name = splitTab[1]
            let index = splitTab[2]
            console.log("[INFO] INDEX field", splitTab, splitTab[0], splitTab[1],index );

            // let cpProducts = [].concat(this.state.sale.products)
            let cpSale = Object.assign({}, this.state.sale)
            let cpProducts = cpSale.products

            // let errorQuantity = false
            // let valueF = value
            // let maxValue = value
            if(name === "quantity" ) {   
                if(value === "" || regex.test(value)){ // update value only if its a int  
                    // this.state.stocks.map(
                    //     (item, i) => {
                    //         console.log("[DEBUG], quantity ",cpProducts[index], " vs  ",item.product )
                    //         if  (item.quantity < value && cpProducts[index].display.value === item.product.id){
                    //             console.log("Max quantity", item )
                    //             maxValue = item.quantity
                    //             errorQuantity = true
                    //         }
                    //     }
                    // )
                    if( value <= cpProducts[index].max ){
                        cpProducts[index].quantity = value
                    } else {
                        cpProducts[index].quantity = cpProducts[index].max
                        
                    }
                    
                }
            } 
            // Too much quantity
            // if (errorQuantity){
            //     valueF =  maxValue
            // }
            // cpProducts[index][name] = valueF
            this.setState({
                ...this.state,
                sale: cpSale
            })
                
        } else {
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    [field]:value
                }
            })
        }
    }
    handleAddProd = () => {// must add new line in the form to add a product to the sale
        console.log("ADD LINE, stocks ", this.state.stocks)
        let sizeStock = 0
        this.state.stocks.map( (item) => {
                if (item.quantity != 0){
                    sizeStock = sizeStock +1 
                }
            }
        )
        if (this.state.numberProd >= sizeStock) {
            return
        }
        let cpSale = Object.assign({}, this.state.sale)
        let cpErrors = Object.assign({}, this.state.errors)
        
        cpSale.products.push({
            display:{},
            product_id:"",
            quantity:"",
            max:"",
        })
        cpErrors.products.push({                      
            product_id:"",
            quantity:"",
        })
        this.setState({
            ...this.state,
            sale: cpSale,
            errors: cpErrors,
            numberProd: this.state.numberProd + 1,
            
        })   
    }
    onChangePage = (pageOfItems, currentPage, rowsPerPage) => {
        this.setState({ pageOfItems, currentPage, rowsPerPage });
    }
    notif = (type, msg, title = null) => {
        this.setState({
            notif: {
                title: title, 
                type, 
                message:msg,
                show:true
            }
        })
    }
    render() {
        const { headerMenu, prospectOptions, prospectOptionsInfos, confirmDelete, contratValueNeedProductID, contratNeedStockManagement, fetchingStocks, stocks } = this.state;
        const { title, message, type, show  } = this.state.notif;
        const { SUBSCRIPTIONS, commercialList, PROSPECTS } = this.props;

        let contentArray = !isEmpty(PROSPECTS) ? this.createClientList() : {list: [], all: []}
        
        // Check that contract do not need Id product 
        // let contratValueNeedProductID = false;
        // let contratNeedStockManagement = false;
        
        console.log("[DEBUG] ", {contentArray, LIST: contentArray.list, all: contentArray.all})

        return (
            <div>
                {(show)  && 
                    <Notif 
                        show={show} 
                        title={title} 
                        type={type} 
                        message={message} 
                        close={()=> this.setState({
                            notif:{
                                title:"",
                                message:"",
                                type:"",
                                show:false,
                            }
                        })}
                    />
                }
                {(prospectOptions && prospectOptionsInfos) &&
        
                <Dialog
                    title={`Options pour ${prospectOptionsInfos.Nom || prospectOptionsInfos["Nom du Client"]} ${prospectOptionsInfos.Prénom || prospectOptionsInfos["Prénom Du Client"]}`}
                    block={prospectOptions}
                    noScroll
                    close={this.handleClose}
                    submitAction={ confirmDelete ?  this.deleteClient : null}
                    submitTitle="Supprimer"
                >
                    { confirmDelete ? (
                        <div>
                            <h4>Confirmer la suppression</h4>
                            <form className="horizontal-form" method='post' onSubmit={this.deleteClient} action="?">
                                <InputText type="password" name="mdpAdmin" value={this.state.mdpAdmin} change={this.handleChange} title="Mot de Passe *" placeholder="..." />
                            </form>
                        </div>
                    ):(

                    <div>
                        <CardButton 
                            action={() => this.ClickForValidation(prospectOptionsInfos.ID)} 
                            title={`Valider le ${NAMES[headerMenu]}`}
                            icon={<CheckBoxRounded style={{ color: blue[300]}}/>}
                        />
                            
                        {headerMenu === "Prospect" &&
                            <CardButton 
                                action={() => this.askDevis(prospectOptionsInfos)} 
                                title="Demander un Devis"
                                icon={<AssignmentOutlined color="primary" />}
                            /> 
                        }
                        {headerMenu === "WaitForInstallation" &&
                            <CardButton 
                                action={() => this.changeInstallateur(prospectOptionsInfos.ID)} 
                                title="Modifier l'installateur"
                                icon={<AssignmentOutlined color="primary" />}
                            /> 
                        }
                        <CardButton 
                            action={()=> this.setState({confirmDelete : true})}
                            title={`Supprimer le ${NAMES[headerMenu]}`}
                            icon={<DeleteOutlineRounded color="error" />}
                        /> 

                    </div>
                    )}
                </Dialog>
                }
                {this.state.popupUserInfo &&
                    <PaygPopupInfo 
                        boxAssoId={this.state.userID}
                        userID={this.state.userID}
                        closePopup={()=>this.setState({popupUserInfo: false, clientInfo: {}})}
                        clientInfo={this.state.clientInfo}
                        USER_INFO_LIST = {["PROSPECT", "USER", "OTHER", "FAMILY","QUOTE"]}
                        // PAYMENTS_INFO_LIST = {["LIST"]} 
                        QUOTATION_INFO_LIST
                        PHOTO
                        NO_DASHBOARD
                        default_tab={"INFO"}
                        home
                        prospect
                    />
                }
                { this.state.popupStateValidationProspect &&
                    <RegisterProspectFormList
                        user={this.state.userToChange}
                        popupStateButton={this.state.popupStateValidationProspect}
                        name="Valider un prospect"
                        onValidation={this.validContrat}
                        onCancelation={this.cancelInput}
                    />
                }
                { this.state.popupStateHasPayed &&
                    <PlanInstallationJsonForm
                        installator={this.state.installatorlist}
                        user={this.state.userToChange}
                        popupStateButton={true}
                        changeInstallateur={false}
                        name="Planifier une installation"
                        onValidation={this.validContrat}
                        onCancelation={this.cancelInput}
                    />
                }
                { this.state.popupChangeTech &&
                    <PlanInstallationJsonForm
                        installator={this.state.installatorlist}
                        user={this.state.userToChange}
                        popupStateButton={true}
                        changeInstallateur={true}
                        name="Changer Installateur"
                        onValidation={this.validContrat}
                        onCancelation={this.cancelInput}
                    />
                }
                { this.state.popupStateInstallation &&
                    <RegisterInstallationJsonForm
                        installator={this.state.installatorlist}
                        user={this.state.userToChange}
                        changeInstallateur={false}
                        popupStateButton={true}
                        name="Enregistrer une installation"
                        onValidation={this.validContrat}
                        onCancelation={this.cancelInput}
                    />
                }
                {this.state.popupStateValidationContrat && 
                    
                    <PopUp
                        title="Attribuer un Contrat"
                        close={this.cancelInput}
                        submitAction={this.validContrat}
                        scroll="body"
                    >
                        <Grid container spacing={2}>
                            <Grid item sm={12} md={6}>
                                <InputSelect
                                    labelWidth={150}
                                    required
                                    label="Type de contrat"
                                    value={this.state.contratValue}
                                    onChange={(option,value) => this.setState({ 
                                        contratValue: value, 
                                        contratLabel: option.label, 
                                        stocks:[],
                                        numberProd: 1,
                                        sale: Object.assign({}, initSale),
                                        errors: Object.assign({},initErrors),
                                        contratValueNeedProductID : option.item.needProductID, 
                                        contratNeedStockManagement : !isEmpty(option.item.stocklink) && option.item.stocklink !== "nolink",
                                    }) 
                                    }
                                    options={ this.state.subscriptionlist.map( item => ( 
                                        { value:item.idobj,  
                                            label:item.id , 
                                            disabled: item.status === "Disabled", 
                                            item: item 
                                        })
                                    )}
                                />

                                {this.state.contratValue && ! isEmpty(SUBSCRIPTIONS) && SUBSCRIPTIONS[this.state.contratValue] &&
                                    <Box className="text-center">
                                        <i> 
                                            Type: <b>{SUBSCRIPTIONS[this.state.contratValue].type}</b>  -
                                        </i>
                                        <i> 
                                            Mensualité: <b> <Currency value={SUBSCRIPTIONS[this.state.contratValue].mensualite} />
                                            </b> - 
                                        </i>
                                        <i> 
                                            Total: <b> <Currency value={SUBSCRIPTIONS[this.state.contratValue].total} /> </b>
                                        </i>
                                    </Box>
                                }
                            </Grid>
                            
                            <Grid item sm={12} md={6}>
                                <InputSelect
                                    labelWidth={150}
                                    label="Commercial Vendeur"
                                    required
                                    value={this.state.sellerAgent}
                                    onChange={(option,value) => this.fetchCommercialStocks(value) }
                                    options={Object.keys(commercialList).map( item => ( 
                                        { value: commercialList[item].id,  label:`${commercialList[item].externalid} - ${commercialList[item].name}` }
                                        ))
                                    }
                                />
                            </Grid>
                            
                            { contratNeedStockManagement && 
                            // this.state.sellerAgent != "none" && 
                            !isEmpty(this.state.sellerAgent) &&

                                <Grid item sm={12}>
                                    { fetchingStocks ?
                                        <Box p={1} style={{ textAlign: "center" }}>
                                            <CircularProgress color="secondary" />
                                            <Typography variant="button">Chargement des Produits</Typography>
                                        </Box>
                                        :
                                        <TableContainer>
                                            <Table className="table table-striped table-bordered">
                                            <TableHead>
                                                <TableRow>
                                                <TableCell>Produit</TableCell>
                                                <TableCell>Quantité</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>{this.createAddFormOLD()}
                                                <TableRow className="plus-btn" onClick={this.handleAddProd}>
                                                        <TableCell colSpan={2}>
                                                            <Link color="secondary"> 
                                                                <Button color="secondary" startIcon={<AddCircleRounded />} >
                                                                    <b>Ajouter un produit</b>
                                                                </Button>
                                                            </Link>
                                                        </TableCell>
                                                    </TableRow>
                                            </TableBody>
                                            </Table>
                                        </TableContainer>
                                        //  <TableBody>
                                        //  </TableBody>

                                        // <FormLayout 
                                        //     {...this.state}
                                        //     rea
                                        //     title={"Produits"}
                                        //     createAddForm={this.createAddForm}
                                        //     onClick={this.handleAddProd}
                                        //     colSpan={2}
                                        // />
                                        
                                    }
                                </Grid>
                            }
                            {contratValueNeedProductID &&
                            <Grid item sm={12} md={6}>
                                <InputText 
                                    label="Code Produit" 
                                    required 
                                    type="text" 
                                    onChange={this.onChangeProductID} 
                                    value={this.state.productID} 
                                    name="ID Produit" 
                                />
                            </Grid> 
                            }
                            <Grid item sm={12} md={6}>
                                <InputText 
                                    label="Commission Vente (Si 0 non pris en compte)" 
                                    required 
                                    type="number" 
                                    onChange={this.handleChange} 
                                    value={this.state.commission} 
                                    name="commission" 
                                />
                            </Grid>
                            <Grid item sm={12} md={6}>
                                <TextArea
                                    label="Remarques"
                                    required 
                                    className="form-control fg-input" 
                                    onChange={this.handleChange} 
                                    value={this.state.comment} 
                                    name="comment" 
                                    rows={4}
                                />
                            </Grid>
                        </Grid>
                    </PopUp>
                }
                {this.state.popupState &&
                    <PopUp
                        close={this.cancelChange}
                        submitAction={this.validChange}
                        title={this.state.headerNamePopupName}
                        scroll="body"
                        disabledSubmit={this.state.disabledValidationButton}
                    >
                        <Box p={1}>{this.state.recapChange}</Box>
                        { !isEmpty(this.state.sale.products) && 
                        this.state.sale.products[0].display.value != "" &&
                        <Box p={2}>
                            <TableLayout>
                                <TableBody>
                                    <TableRow>
                                        <TableCell rowSpan={this.state.sale.products.length+1}>Produits</TableCell>
                                        <TableCell>Nom</TableCell>
                                        <TableCell>Quantité</TableCell>
                                    </TableRow>
                                    {this.state.sale.products.map( (item,i) => {
                                        if (item.display.label !== ""){
                                            return <TableRow style={{backgroundColor: "lightyellow"}} key={i}>
                                                <TableCell style={{width: "400px"}}>{item.display.label}</TableCell>
                                                <TableCell><b>{item.quantity}</b> </TableCell>
                                            </TableRow>
                                        }}
                                    )
                                    }
                                </TableBody>
                            </TableLayout>
                        </Box>
                        }
                        { this.state.error && 
                            <Alert severity="error" >
                                <AlertTitle>Erreur</AlertTitle>
                                {this.state.error}
                            </Alert> 
                        }
                    </PopUp>
                }
                {this.state.popupStateValidationPayment &&
                    <PopUp
                        maxWidth="sm"
                        title="Confirmer"
                        submitAction={this.validPayment}
                        close={this.cancelInput}
                    >
                        <p>
                            Validation du paiement pour le client {this.getName(this.state.userToChange)}
                        </p>
                    </PopUp>
                }
            
                <div>
                    <InputText 
                        type="text" 
                        label="Rechercher"
                        name="search" 
                        value={this.state.search} 
                        autoComplete="off"
                        onChange={ (e)=> this.setState({search: e.target.value, currentPage: 0})} 
                    /> 
                </div>
                <div>
                    <ClientTab 
                        headerMenu={headerMenu} 
                        changeMenu={
                            (menu) => this.setState({headerMenu: menu, currentPage: 0})
                        }
                    >
                        {!isEmpty(PROSPECTS[headerMenu]) && 
                            <TableLayout>
                                <TableHead style={{ whiteSpace: "normal"}}>
                                    <TableRow>
                                        {PROSPECTS[headerMenu].headers.slice(0, 10).map(
                                            header => (
                                                <TableCell component="th" style={{ "textTransform": "capitalize"}}>{header}</TableCell>
                                            ))
                                        }
                                        <TableCell component="th" >Options</TableCell>
                                        {/* {headerMenu === "WaitForInstallation" && 
                                            <TableCell>Installation</TableCell>
                                        } */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {contentArray.list}
                                </TableBody>
                                <TableFooterPagination
                                    colSpan={PROSPECTS[headerMenu].headers.length > 10 ? 10 : PROSPECTS[headerMenu].headers.length + 1}
                                    // items={contentArray.all} 
                                    count={size(contentArray.all)} 
                                    onChangePage={this.onChangePage} 
                                    initialPage={this.state.currentPage} 
                                />
                            </TableLayout>  
                        }       
                        {this.props.STATE.prospects.fetching &&
                            <Box>
                                <Spin noOverlay />
                            </Box>
                        }           
                    </ClientTab>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state){
    return {
        STATE: state.inventory.requestState,
        SUBSCRIPTIONS: state.subscriptions,
        INSTALLERS: state.installers,
        PROSPECTS: state.prospects.LIST,
        commercialList: state.agents.agents,
    }
}

function mapDispatchToProps(dispatch){  
    return bindActionCreators({
        askDevis,
        fetchProspectsType,
        fetchAgents,
        fetchSubscriptions,
        fetchInstallers,
        // fetchCommercialStocks
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientList)
